export function getUrlParam(param: string) {
	//@ts-ignore
	const params = new URL(document.location).searchParams;
	return params?.get(param);
}
